<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountCircle } from "@mdi/js";
export default {
  name: "MdiAccountCircleOutline",
  data() {
    return {
      svgPath: mdiAccountCircle,
    };
  },
};
</script>
